<template>
  <div>
    <b-loading
      :is-full-page="true"
      :active="isLoading"
      :can-cancel="false"
    ></b-loading>

    <h2 class="subtitle">{{ $t("settings.payments") }}</h2>

    <div class="columns">
      <div class="column is-one-third">
        <b-field :label="$t('settings.isEcommercePaymentActive')">
          <b-switch
            size="is-small"
            class="option"
            type="is-primary"
            v-model="storeBeingManaged.payments.ecommerce.isActive"
            passive-type="is-secondary"
            @input="setEcommercePayment"
          ></b-switch>

          {{
            storeBeingManaged.payments.ecommerce.isActive
              ? $t("common.Enabled")
              : $t("common.Disabled")
          }}
        </b-field>
      </div>

      <div
        class="column is-one-third"
        v-if="storeBeingManaged.payments.ecommerce.isActive"
      >
        <b-field :label="$t('settings.isCartValueLimitActive')">
          <b-switch
            size="is-small"
            class="option"
            type="is-primary"
            v-model="
              storeBeingManaged.payments.ecommerce.isCartValueLimitActive
            "
            passive-type="is-secondary"
            @input="setEcommerceCartValueLimitActive"
          ></b-switch>

          {{
            storeBeingManaged.payments.ecommerce.isCartValueLimitActive
              ? $t("common.Enabled")
              : $t("common.Disabled")
          }}
        </b-field>
      </div>

      <div
        class="column is-one-third"
        v-if="
          storeBeingManaged.payments.ecommerce.isActive &&
            storeBeingManaged.payments.ecommerce.isCartValueLimitActive
        "
      >
        <b-field
          :label="$t('settings.cartValueLimit')"
          label-position="on-border"
          style="position: relative; top: 10px;"
        >
          <money
            v-model="storeBeingManaged.payments.ecommerce.cartValueLimit"
            v-bind="money"
            class="input is-expanded"
            @blur.native="setEcommerceCartValueLimit"
          ></money>
        </b-field>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { common } from "../../mixins/common";
import { mask } from "../../mixins/mask";
import { Money } from "v-money";

export default {
  mixins: [common, mask],

  data() {
    return {
      isLoading: false,
      money: {
        decimal: ",",
        thousands: ".",
        prefix: "R$ ",
        precision: 2
      },
      initialCartValueLimit: 0
    };
  },

  components: {
    Money
  },

  computed: {
    ...mapGetters(["storeBeingManaged"])
  },

  methods: {
    setEcommercePayment() {
      this.isLoading = true;
      this.$store
        .dispatch("setEcommercePayment", {
          storeId: this.storeBeingManaged._id,
          status: this.storeBeingManaged.payments.ecommerce.isActive
        })
        .then(res => {
          if (res.data.result === "ok") {
            this.$buefy.toast.open({
              message: `${this.$t("settings.ecommercePayments")} ${
                this.storeBeingManaged.payments.ecommerce.isActive
                  ? this.$t("common.enabled-f")
                  : this.$t("common.disabled-f")
              }!`,
              type: "is-success",
              position: "is-bottom",
              duration: 5000
            });
          } else {
            this.storeBeingManaged.payments.ecommerce.isActive = !this
              .storeBeingManaged.payments.ecommerce.isActive;
            this.alertError(res.data);
          }
        })
        .catch(() => {
          this.storeBeingManaged.payments.ecommerce.isActive = !this
            .storeBeingManaged.payments.ecommerce.isActive;
          this.alertError({ message: "UNEXPECTED_ERROR" });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },

    setEcommerceCartValueLimitActive() {
      this.isLoading = true;
      this.$store
        .dispatch("setEcommerceCartValueLimitActive", {
          storeId: this.storeBeingManaged._id,
          status: this.storeBeingManaged.payments.ecommerce
            .isCartValueLimitActive
        })
        .then(res => {
          if (res.data.result === "ok") {
            this.$buefy.toast.open({
              message: `${this.$t("settings.cartValueLimit")} ${
                this.storeBeingManaged.payments.ecommerce.isCartValueLimitActive
                  ? this.$t("common.enabled-f")
                  : this.$t("common.disabled-f")
              }!`,
              type: "is-success",
              position: "is-bottom",
              duration: 5000
            });
          } else {
            this.storeBeingManaged.payments.ecommerce.isCartValueLimitActive = !this
              .storeBeingManaged.payments.ecommerce.isCartValueLimitActive;
            this.alertError(res.data);
          }
        })
        .catch(() => {
          this.storeBeingManaged.payments.ecommerce.isCartValueLimitActive = !this
            .storeBeingManaged.payments.ecommerce.isCartValueLimitActive;
          this.alertError({ message: "UNEXPECTED_ERROR" });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },

    setEcommerceCartValueLimit() {
      if (
        this.storeBeingManaged.payments.ecommerce.cartValueLimit ===
        this.initialCartValueLimit
      ) {
        return;
      }

      this.isLoading = true;
      this.$store
        .dispatch("setEcommerceCartValueLimit", {
          storeId: this.storeBeingManaged._id,
          cartValueLimit: this.formatMoneyToCents(
            this.storeBeingManaged.payments.ecommerce.cartValueLimit
          )
        })
        .then(res => {
          if (res.data.result === "ok") {
            this.$buefy.toast.open({
              message: this.$t("settings.cartValueLimitUpdated"),
              type: "is-success",
              position: "is-bottom",
              duration: 5000
            });
            this.initialCartValueLimit =
              this.formatMoneyToCents(
                this.storeBeingManaged.payments.ecommerce.cartValueLimit
              ) / 100;
          } else {
            this.storeBeingManaged.payments.ecommerce.cartValueLimit = this.initialCartValueLimit;
            this.alertError(res.data);
          }
        })
        .catch(() => {
          this.alertError({ message: "UNEXPECTED_ERROR" });
        })
        .finally(() => {
          this.isLoading = false;
        });
    }
  },

  mounted() {
    this.initialCartValueLimit = this.storeBeingManaged.payments.ecommerce.cartValueLimit;
  }
};
</script>

<style scoped>
.option-switch {
  position: relative;
  top: 2px;
}
</style>
